import { WorkflowElement } from "../element"

export class UnstartedSubscriber extends WorkflowElement {
  static get elementName() {
    return "workflow-unstarted-subscribers"
  }

  connectedCallback() {
    this.innerHTML = this.text
  }

  get text() {
    var text = ""
    var subscribers = ""

    if (this.dataset.unstarted_count == 1) {
      subscribers = "subscriber"
    } else {
      subscribers = "subscribers"
    }

    if (this.dataset.live != "true") {
      text = `<strong>${this.dataset.unstarted_count} ${subscribers} waiting here.</strong><br /><em>This automation is paused. Publish it to move your subscribers to the next step.</em>`
    } else {
      text = `${this.dataset.unstarted_count} ${subscribers} waiting here.`
    }

    return text
  }
}

customElements.get(UnstartedSubscriber.elementName) ||
  customElements.define(UnstartedSubscriber.elementName, UnstartedSubscriber)
